<template>
  <v-container>
    <!--        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>-->
    <h1>{{ doc.title }}</h1>
    <v-row>
      <v-col>
        <v-card class="pa-4">
          <v-card-text>
            <v-form ref="form" name="documents">
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="doc.title" name="title" label="Название"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="doc.description"
                    label="Описание"
                    name="description"
                  ></v-text-field>
                </v-col>
              </v-row>
              <file-input
                v-if="!isEdit"
                :accept="'*'"
                @file-selected="fileSelected"
                field-name="file"
              ></file-input>
              <input type="text" name="site_key" :value="$attrs.site_key" style="display: none" />
            </v-form>
          </v-card-text>
          <v-card-text v-if="isEdit">
            <v-col cols="12">
              <v-text-field label="Постоянная ссылка" :placeholder="doc.url" single-line filled>
                <template v-slot:prepend>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn icon @click="copyClipboard" color="primary" v-on="on">
                        <v-icon>mdi-content-copy</v-icon>
                      </v-btn>
                    </template>
                    <span>Скопировать ссылку</span>
                  </v-tooltip>
                </template>
                <template v-slot:append>
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <v-btn icon :href="doc.url" target="_blank" color="primary" v-on="on">
                        <v-icon>mdi-open-in-new</v-icon>
                      </v-btn>
                    </template>
                    <span>Загрузить файл</span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="save" color="success">Сохранить</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FileInput from '@/components/FileInput'

export default {
  name: 'create_edit',
  components: { FileInput },
  data() {
    return {
      doc: {
        title: '',
      },
    }
  },
  computed: {
    breadcrumbs() {
      return [
        {
          disabled: false,
          to: { name: 'documents' },
          text: 'Документы',
        },
        {
          to: { name: this.$route.name, params: this.$route.params },
          text: this.doc.title,
          disabled: false,
        },
      ]
    },
    isEdit() {
      return !!this.$route.params.id
    },
  },
  mounted() {
    if (this.isEdit) {
      this.updateData()
    }
  },
  methods: {
    copyClipboard() {
      const el = document.createElement('textarea')
      el.value = this.doc.url
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      // this.showSnackbar(`Ссылка ${this.doc.url} записана в буфер обмена`)
      this.showSnackbar('Скопировано', 'green')
    },
    fileSelected(f) {
      this.doc.file = f
    },
    updateDoc() {
      this.axios({
        url: `/v1/documents/${this.doc.id}`,
        method: 'patch',
        data: {
          title: this.doc.title,
          description: this.doc.description,
        },
      })
        .then((resp) => {
          this.doc = resp.data
          this.showSnackbar('Сохранено', 'green')
        })
        .catch((err) => {
          this.showSnackbar(err.response.data, 'error')
        })
    },
    save() {
      if (this.isEdit) {
        this.updateDoc()
        return
      }
      const form = this.$refs.form
      const data = new FormData(form.$el)
      this.axios({ url: '/v1/documents', method: 'post', data: data }).then((resp) => {
        this.doc = resp.data
        this.showSnackbar('Сохранено', 'green')
        this.$router.push({ name: 'documents_edit', params: { id: this.doc.id } })
      })
    },
    updateData() {
      this.axios({ url: `/v1/documents/${this.$route.params.id}`, method: 'get' })
        .then((resp) => {
          this.doc = resp.data
        })
        .catch((err) => {
          this.showSnackbar(err.response.data, 'error')
        })
    },
  },
}
</script>
